import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Doughnut } from 'react-chartjs-2';
import CustomBetsCardMade from './CustomBetsCardMade'
import CustomBetsCardTaken from './CustomBetsCardTaken'
import CustomBetsCard from './CustomBetsCard'
import CancelCustomWager from './customWagerStages/CancelCustomWager'
//import PayoutCustomWager from './customWagerStages/PayoutCustomWager'
import SubmitVote from './customWagerStages/SubmitVote'
import Judgements from './Judgements'
import FinalizeAbandoned from './customWagerStages/FinalizeAbandoned'
import Countdown from 'react-countdown-now';
import { Tabs, Icon } from 'antd';
const zeroAddress = "0x0000000000000000000000000000000000000000";
@observer(["ViewStore", "UserStore"])
class MyCustomBets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            renderedMadeCustomWagerList: [],
            renderedTakenCustomWagerList: [],
            loadedWagers: false,
        };
        this.renderAllCustomWagersAtOnce = this.renderAllCustomWagersAtOnce.bind(this);
        this.renderCustomWagersComponents = this.renderCustomWagersComponents.bind(this);
        this.renderCustomWagersComponent = this.renderCustomWagersComponent.bind(this);
        this.renderStage = this.renderStage.bind(this);
    }

    async componentWillMount() {
        let self = this;
        setTimeout(() => { self.renderAllCustomWagersAtOnce(); }, 950)
        setTimeout(() => { self.setState({ loadedWagers: true }); }, 1050)
    }

    renderAllCustomWagersAtOnce() {
        const { UserStore } = this.props;

        let customWagerListMade = [];
        let customWagerListTaken = [];
        let customWagersAllObjectList = [];
        let timeNowValue = Date.now() / 1000;

        for (let customWager of UserStore.customWagersMade.values()) {
            customWagerListMade.push(customWager);
        }

        for (let customWager of UserStore.customWagersTaken.values()) {
            customWagerListTaken.push(customWager);
        }

        for (let customWager of customWagerListMade) {
            if (customWager.cancelled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "cancelled"
                });
            // } else if (customWager.taker !== "" && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote && customWager.settled && (timeNowValue > customWager.reportingEndTime)) {
            //     customWagersAllObjectList.push({
            //         wager: customWager,
            //         maker: true,
            //         status: "dispute-settled-not-paid"
            //     });
            // } else if (customWager.taker !== "" && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.settled && customWager.makerWinVote !== customWager.takerWinVote) {
            //     customWagersAllObjectList.push({
            //         wager: customWager,
            //         maker: true,
            //         status: "dispute-settled-paid"
            //     });
            } else if (customWager.settled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "settled"
                });
            }
            else if (customWager.taker == "" && timeNowValue < customWager.endTime) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "untaken-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-post-end-time-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-post-reporting-end-time"
                });
                // } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                //     customWagersAllObjectList.push({
                //         wager: customWager,
                //         maker: true,
                //         status: "maker-taker-voted-post-reporting-end-time"
                //     });
            } else if (customWager.taker == "" && timeNowValue > customWager.endTime) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "untaken-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-pre-end-time-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-post-end-time-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote == customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "settled-no-dispute"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-post-reporting-end-time"
                });
            }
        }

        for (let customWager of customWagerListTaken) {
            if (customWager.cancelled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "cancelled"
                });
            // } else if (customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote && customWager.settled && (timeNowValue > customWager.reportingEndTime)) {
            //     customWagersAllObjectList.push({
            //         wager: customWager,
            //         taker: true,
            //         status: "dispute-settled-not-paid"
            //     });
            // } else if ((timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.settled && customWager.makerWinVote !== customWager.takerWinVote) {
            //     customWagersAllObjectList.push({
            //         wager: customWager,
            //         taker: true,
            //         status: "dispute-settled-paid"
            //     });
            } else if (customWager.settled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "settled"
                });
            }
            else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-post-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-post-reporting-end-time"
                });
                // } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                //     customWagersAllObjectList.push({
                //         wager: customWager,
                //         taker: true,
                //         status: "maker-taker-voted-post-reporting-end-time"
                //     });
            } else if ((timeNowValue < customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-pre-end-time-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-post-end-time-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-post-end-time-post-reporting-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-pre-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-pre-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-pre-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote == customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "settled-no-dispute"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-pre-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-post-reporting-end-time"
                });
            }
        }

        this.renderCustomWagersComponents(customWagersAllObjectList);
    }

    renderCustomWagersComponent(wager, status, makerTaker) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(wager.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        return (
            <CustomBetsCard
                key={wager._id}
                status={status}
                wager={wager}
                makerTaker={makerTaker}
                stage={this.renderStage(status, wager, makerTaker)}
            />
        );
    }

    renderCustomWagersComponents(wagerListObj) {
        let customWagerListObj = [];
        let customWagerListObjMade = [];
        let customWagerListObjTaken = [];
        for (let customWager of wagerListObj) {
            if (customWager.maker) {
                customWagerListObjMade.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "maker"));
                customWagerListObj.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "maker"));
            } else if (customWager.taker) {
                customWagerListObjTaken.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "taker"));
                customWagerListObj.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "taker"));
            }
        }
        if (customWagerListObj.length === 0) {
            customWagerListObj = <div className="my-bets-page-cards-wagers-wager-options-stage" style={{ fontSize: "22pt" }}>NO CUSTOM BETS FOUND<div><Icon type="file-search" /></div></div>;
        }
        this.setState({ renderedMadeCustomWagerList: customWagerListObjMade })
        this.setState({ renderedTakenCustomWagerList: customWagerListObjTaken })
        this.setState({ renderedAllCustomWagerList: customWagerListObj })
    }

    renderStage(status, wager, makerTaker) {

        let stageComponent = [];

        if (status == "untaken-pre-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for match</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><CancelCustomWager wager={wager} /></div>
            </div>);
        }
        else if (status === "settled-no-dispute" || status === "settled") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;

            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }

            if (makerTaker == "taker") {
                if (takerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span>
                    </div>);
                } else if (makerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>
                        YOU LOST</span>
                    </div>);
                } else if (noWinner) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span>
                    </div>);
                }

            } else {
                if (makerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span>
                    </div>);
                } else if (takerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span>
                    </div>);
                } else if (noWinner) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span>
                    </div>);
                }
            }
        } else if (status == "untaken-post-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Never found a match</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><CancelCustomWager wager={wager} /></div>
            </div>);
        } else if (status == "no-votes-pre-end-time-pre-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Matched</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                VOTING STARTS IN <Countdown zeroPadLength={2} date={new Date(wager.endTime).getTime() * 1000}>
                    <span>ENDED, NO TIME</span>
                </Countdown>
            </div>);
        } else if (status == "no-votes-post-end-time-pre-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Reached end time</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                <SubmitVote wager={wager} makerTaker={makerTaker} />
            </div>);
        }
        else if (status == "no-votes-post-end-time-post-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Reporting period is over. You may still vote but you may also finalize for a refund.</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /><FinalizeAbandoned wager={wager} /></div>
            </div>);
        } else if (status == "only-maker-voted-pre-reporting-end-time") {
            if (makerTaker == "maker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        }
        else if (status == "only-maker-voted-post-reporting-end-time") {
            if (makerTaker == "maker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote, you may now finalize for a refund.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><FinalizeAbandoned wager={wager} /></div>
                </div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner to finalize the bet.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        } else if (status == "only-taker-voted-post-reporting-end-time") {
            if (makerTaker == "taker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote, you may now finalize for a refund.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><FinalizeAbandoned wager={wager} /></div>
                </div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner to finalize the bet.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        } else if (status == "only-taker-voted-post-end-time") {
            if (makerTaker == "taker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        } else if (status == "only-maker-voted-post-end-time") {
            if (makerTaker == "maker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        }
        else if (status == "maker-taker-voted-post-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">WINNER NOT YET DETERMINED - FINALIZE FOR REFUND</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><FinalizeAbandoned wager={wager} /></div>
            </div>);
        } else if (status == "maker-taker-voted-post-end-time") {
            if (makerTaker == "maker") {
                // stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{JSON.stringify(wager)}</div>);      
                if (wager.makerWinVote === wager.takerWinVote) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED WITH NO DISPUTE</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{wager.makerWinVote === wager.makerChoice ?
                        <span style={{ color: '#27f727' }}>YOU WON</span> : <span style={{ color: 'rgb(245, 60, 64)' }}>
                            YOU LOST</span>}</div>);

                } else {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">THERE HAS BEEN A DISPUTE {wager.judge !== zeroAddress ?
                        "- WAITING FOR JUDGE SETTLEMENT" :
                        "YOU MAY TRIGGER A REFUND WHEN THE REPORTING PERIOD ENDS"}</div>);

                }





            } else {
                // stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{JSON.stringify(wager)}</div>);        
                if (wager.makerWinVote === wager.takerWinVote) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED WITH NO DISPUTE</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{wager.makerWinVote === wager.makerChoice ?
                        <span style={{ color: 'rgb(245, 60, 64)' }}>
                            YOU LOST</span> : <span style={{ color: '#27f727' }}>YOU WON</span>}</div>);

                } else {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">THERE HAS BEEN A DISPUTE {wager.judge !== zeroAddress ?
                        "- WAITING FOR JUDGE SETTLEMENT" :
                        "YOU MAY TRIGGER A REFUND WHEN THE REPORTING PERIOD ENDS"}</div>);

                }



            }
        }
        else {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{status}</div>);
        }
        return stageComponent;
    }

    render() {
        const TabPane = Tabs.TabPane;
        return (
            <div className="my-custom-bets">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="All" key="1">
                        <div>
                            {this.state.loadedWagers ? this.state.renderedAllCustomWagerList : <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />}
                        </div>
                    </TabPane>
                    <TabPane tab="YOU MADE" key="2">
                        <div>
                            {this.state.loadedWagers ? this.state.renderedMadeCustomWagerList : <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />}
                        </div>
                    </TabPane>
                    <TabPane tab="YOU'VE TAKEN" key="3">
                        <div>{this.state.loadedWagers ? this.state.renderedTakenCustomWagerList : <Icon style={{ marginLeft: "47%", fontSize: '46px', color: '#08c' }} type="loading" />}</div>
                    </TabPane>
                    <TabPane tab="JUDGEMENTS" key="4">
                        <div><Judgements /></div>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default inject('store')(observer(MyCustomBets));


// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyCustomBets.js